import { FC, PropsWithChildren } from "react";

const TitlePage: FC<PropsWithChildren> = ({ children }) => (
  <div className="text-md font-bold">{children}</div>
);

export default TitlePage;
